import { render, staticRenderFns } from "./ExpensesDetails.vue?vue&type=template&id=ce3fc146&scoped=true"
import script from "./ExpensesDetails.vue?vue&type=script&lang=js"
export * from "./ExpensesDetails.vue?vue&type=script&lang=js"
import style0 from "./ExpensesDetails.vue?vue&type=style&index=0&id=ce3fc146&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce3fc146",
  null
  
)

export default component.exports